<app-notification
        [title]="titleString" 
        [notificationText]="textString" 
        [btnText]="btnString" 
        [btnFlag]="btnFlag" 
        [msgCode]="messageCode" 
        [difference]="compDifference"
        [isLngIsBest]="isLngIsBest"
        [displayWOMPanel]="displayWOMPanel"
        [padsRefNumber]="padsRefNumber" [comparatorError]="quoteResult.compQuote.errorMessage" [consentMessageError]="consentMessage"></app-notification>